<div class="events-wrapper">
  <app-events-view-table *ngIf="!isLegacy" [clientSettings]="clientSettings"></app-events-view-table>
</div>
